import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * An icon for Grid View
 *
 * @author Praveen Punniyamoorthi
 */
const Grid = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
     // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      d="M9.99984 13.3334C10.368 13.3334 10.6665 13.6319 10.6665 14.0001V20.6667C10.6665
      21.0349 10.368 21.3334 9.99984 21.3334H3.33317C2.96498 21.3334 2.6665 21.0349
      2.6665 20.6667V14.0001C2.6665 13.6319 2.96498 13.3334 3.33317 13.3334H9.99984ZM20.6665
      13.3334C21.0347 13.3334 21.3332 13.6319 21.3332 14.0001V20.6667C21.3332 21.0349 21.0347 21.3334
      20.6665 21.3334H13.9998C13.6316 21.3334 13.3332 21.0349 13.3332 20.6667V14.0001C13.3332 13.6319
      13.6316 13.3334 13.9998 13.3334H20.6665ZM8.33317 15.6667H4.99984V19.0001H8.33317V15.6667ZM18.9998
      15.6667H15.6665V19.0001H18.9998V15.6667ZM9.99984 2.66675C10.368 2.66675 10.6665 2.96522
      10.6665 3.33341V10.0001C10.6665 10.3683 10.368 10.6667 9.99984 10.6667H3.33317C2.96498 10.6667
      2.6665 10.3683 2.6665 10.0001V3.33341C2.6665 2.96522 2.96498 2.66675 3.33317 2.66675H9.99984ZM20.6665
      2.66675C21.0347 2.66675 21.3332 2.96522 21.3332 3.33341V10.0001C21.3332 10.3683 21.0347 10.6667
      20.6665 10.6667H13.9998C13.6316 10.6667 13.3332 10.3683 13.3332 10.0001V3.33341C13.3332
      2.96522 13.6316 2.66675 13.9998 2.66675H20.6665ZM8.33317 5.00008H4.99984V8.33341H8.33317V5.00008ZM18.9998
      5.00008H15.6665V8.33341H18.9998V5.00008Z"
      fill="currentcolor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SvgIcon>
);

export default Grid;
